import React from 'react';
import { Stepper, Step, StepLabel, StepButton } from '@mui/material';
import { FaCheckCircle } from 'react-icons/fa';

const CheckoutStepper = ({ activeStep, steps, onStepClick, completedSteps = [] }) => {
  return (
    <Stepper 
      activeStep={activeStep} 
      alternativeLabel 
      sx={{ 
        mb: 4,
        '& .MuiStepConnector-line': {
          borderColor: '#000000',
        },
        '& .MuiStepLabel-root .Mui-active': {
          color: '#000000',
        },
        '& .MuiStepLabel-root': {
          color: '#000000',
        },
        '& .MuiStepIcon-root': {
          color: '#000000',
          '&.Mui-active': {
            color: '#000000',
          },
        },
        '& .MuiStepButton-root': {
          color: '#000000',
        }
      }}
    >
      {steps.map((step, index) => (
        <Step key={step.label} completed={completedSteps.includes(index)}>
          <StepButton
            onClick={() => onStepClick && onStepClick(index)}
            icon={completedSteps.includes(index) ? <FaCheckCircle color="black" /> : undefined}
            sx={{ color: '#000000' }}
          >
            <StepLabel sx={{ color: '#000000' }}>{step.label}</StepLabel>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default CheckoutStepper;
